var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('h2',[_vm._v("Sorry, we can't find what you're looking for!")]),_c('hr'),_c('EmailCollection'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }